import React from 'react'
import { useSelector } from 'react-redux'
import { selectorTypes } from '@easybutton/constants'

import { getTable } from '../../../../utils/databases'
import { getDatabase } from '../../../../ducks/databases'
import { getAction } from '../../../../ducks/actions'
import EmptyState from '../../../Shared/EmptyState'
import Loading from '../../../Shared/Loading'

import Property from './Property'

import styles from './Steps.module.css'

export default function DatabaseStep({ step, actionId }) {
  const { databaseId, table: tableName } = step
  const database = useSelector(getDatabase(databaseId))
  const action = useSelector(getAction(actionId))

  if (!database || !action) {
    return (
      <EmptyState tight>
        <Loading large />
      </EmptyState>
    )
  }

  const inputs = action.details.inputs || []

  const showSelector = ['update', 'delete'].includes(step.operation)
  const { selector } = step

  let selectorText = ''

  if (selector && selector.type === selectorTypes.INPUT) {
    let input = inputs.filter(i => i.id === selector.inputId)[0]
    selectorText = input && `Inputs > ${input.name}`
  } else if (selector && selector.type === selectorTypes.FIND_BY_COLUMN) {
    selectorText = `Find by ${selector.column}`
  }

  const table = getTable(database, tableName)

  if (!table) {
    return (
      <EmptyState tight>
        <h2>Not Configured</h2>
      </EmptyState>
    )
  }

  const { singularName } = table

  const fields = table.columns
    .map(col => col.name)
    .map(field => ({
      field,
      value: (step.fields || {})[field],
    }))
    .filter(
      itm => itm.value && !(itm.value.length === 1 && itm.value[0] === '')
    )

  const offset = showSelector ? 1 : 0
  const itemCount = fields.length + offset
  const rowCount = Math.ceil(itemCount / 2)
  const firstColCount = rowCount - offset

  const firstCol = fields.slice(0, firstColCount)
  const secondCol = fields.slice(firstColCount)

  return (
    <>
      <h2 className={styles.stepName}>
        {step.operation} {singularName}
      </h2>
      <div className={styles.properties}>
        <div>
          {showSelector && (
            <Property label={`Which ${singularName}?`}>{selectorText}</Property>
          )}
          {firstCol.map(({ field, value }) => (
            <Property key={field} label={field} value={value} action={action} />
          ))}
        </div>
        <div>
          {secondCol.map(({ field, value }) => (
            <Property key={field} label={field} value={value} action={action} />
          ))}
        </div>
      </div>
    </>
  )
}
